var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "mint-button",
      class: [
        "mint-button--" + _vm.type,
        "mint-button--" + _vm.size,
        {
          "is-disabled": _vm.disabled,
          "is-plain": _vm.plain
        }
      ],
      attrs: { type: _vm.nativeType, disabled: _vm.disabled },
      on: { click: _vm.handleClick }
    },
    [
      _vm.icon || _vm.$slots.icon
        ? _c(
            "span",
            { staticClass: "mint-button-icon" },
            [
              _vm._t("icon", function() {
                return [
                  _vm.icon
                    ? _c("i", {
                        staticClass: "mintui",
                        class: "mintui-" + _vm.icon
                      })
                    : _vm._e()
                ]
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("label", { staticClass: "mint-button-text" }, [_vm._t("default")], 2)
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e8de92e2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e8de92e2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/mint-ui/packages/button/src/button.vue
// module id = null
// module chunks = 